import { render, staticRenderFns } from "./HcmDropdownItem.vue?vue&type=template&id=a06bc87e"
import script from "./HcmDropdownItem.js?vue&type=script&lang=js&external"
export * from "./HcmDropdownItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports